import React from 'react'
import ImgVideo from 'assets/images/login/video.jpg'
import { Button, Dialog, useMediaQuery, useTheme } from '@mui/material';
import { PlayCircleOutline } from '@mui/icons-material';

const Video: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div >
      <video controls poster={ImgVideo} className='sizevid-movil'>
        <source src='https://production-cd-crd-resources.storage.googleapis.com/assets/videos/login/video_info.mp4' type="video/mp4" />
      </video>
      <Button onClick={handleClickOpen} className='sizevid-web'>
        <img
          alt="Error 404"
          className='sizevid'
          width='100%'
          height='50%'
          src={ImgVideo}
        />
        <PlayCircleOutline className='play-video' style={{ fontSize: 80 }}>    </PlayCircleOutline>
      </Button>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <video controls >
          <source src='https://production-cd-crd-resources.storage.googleapis.com/assets/videos/login/video_info.mp4' type="video/mp4" />
        </video>
      </Dialog>
    </div>
  )
}

export default Video